/**
 * Paleta de acento por tipo de estadia, espelhando o hi-fi
 * (`Creche Hotel - Painel (hi-fi).dc.html`): creche = laranja, hotel = roxo.
 * Centralizado aqui para não espalhar hex pelos componentes.
 */
export type StayModule = "day_care" | "hotel";

export interface StayAccent {
  solid: string;
  soft: string;
  text: string;
  border: string;
}

export const STAY_ACCENT: Record<StayModule, StayAccent> = {
  day_care: { solid: "#ef643f", soft: "#fdf1ec", text: "#d24f2d", border: "#f1d3c6" },
  hotel: { solid: "#9b42ad", soft: "#f3e4f6", text: "#7e3690", border: "#e6ceec" },
};

export const stayAccent = (module: StayModule): StayAccent => STAY_ACCENT[module];
